import React, { useState, useEffect } from "react";
import RigthPanel from "@/ui-controls/RigthPanel";
import { Application } from "@/api/applications";
import NewAppRoleForm from "@/components/roles/appRoles/NewAppRoleForm";
import { Role } from "@/api/roles";

interface Props {
  application: Application;
  isPanelOpenned: boolean;
  onPanelClosed?: () => any;
  onSave?: (newRole: Role) => any;
}

const NewAppRolePanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header="Add Application Role"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewAppRoleForm}
        childProps={{
          application: props.application,
          onClose: () => {
            onClosePanel();
          },
          onSave: (appRole: Role) => {
            if (props.onSave) props.onSave(appRole);
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default NewAppRolePanel;
